// Generated by CoffeeScript 1.12.6
(function() {
  'use strict';
  angular.module('app.jobApplicationHistory').factory('jobApplicationCRUD', ['$log', '$http', function($log, $http) {}, {}]).factory('jobApplicationEmailID', [
    function() {
      var factory, model;
      factory = {};
      model = {};
      factory.setModel = function(key, value) {
        model[key] = value;
      };
      factory.getModel = function(key) {
        return model[key];
      };
      return factory;
    }
  ]);

}).call(this);



// WEBPACK FOOTER //
// ./scripts/job-application-history/jobApplicationHistoryServices.js